import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iterateObject'
})
export class IterateObjectPipe implements PipeTransform {

  transform(value, args:string[]) : any {
    if (!value) {
      return value;
    } 

    let keys = [];
    for (let key in value) {
      keys.push({key: key, value: value[key]});
    } 
    return keys;
  } 
} 




// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/iterate-object.pipe.ts